import { type HTMLAttributes, type ReactNode } from 'react';

import { Container } from './Panel.styled';

import { Spacing } from '../../../../../../helpers/genericStyles';

type Props = HTMLAttributes<HTMLElement> &
  Spacing & {
    children: ReactNode;
    'aria-label'?: string;
    /** Use 'fieldset' when panel will contain form inputs in the interest of accessibility, and 'div' for display purposes only */
    as?: 'div' | 'fieldset';
  };

const Panel = (props: Props) => {
  const { children, as = 'fieldset', ...rest } = props;

  return (
    <Container as={as} {...rest}>
      {children}
    </Container>
  );
};

export { Panel };
